import { SVGProps, Ref, forwardRef } from 'react';

export const HeartFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M7.998 4.39C5.09.238 0 1.968 0 5.967c0 3.332 4.666 6.03 7.998 8.03 3.333-2 7.998-4.698 7.998-8.03 0-3.798-5.09-5.729-7.998-1.577"
                fill="currentColor"
            />
        </g>
    </svg>
));
HeartFilledSize16Glyph.displayName = 'HeartFilledSize16Glyph';
